import compact from "lodash/compact";
import find from "lodash/find";
import initial from "lodash/initial";
import isNil from "lodash/isNil";
import last from "lodash/last";
import map from "lodash/map";
import split from "lodash/split";
import startsWith from "lodash/startsWith";
import trim from "lodash/trim";

const EVENT_SEPARATOR = /\r?\n\r?\n/;
const LINE_SEPARATOR = /\r?\n/;
const EVENT_FIELD = "event:";
const DATA_FIELD = "data:";
const DEFAULT_EVENT = "message";

export interface ISseEvent {
  event: string;
  data: string;
}

export interface IParsedSseBuffer {
  events: ISseEvent[];
  rest: string;
}

function readField(lines: string[], field: string): string | undefined {
  const line = find(lines, function hasField(candidate) {
    return startsWith(candidate, field);
  });

  if (isNil(line)) {
    return undefined;
  }

  return trim(line.slice(field.length));
}

function toSseEvent(block: string): ISseEvent | undefined {
  const lines = split(block, LINE_SEPARATOR);
  const data = readField(lines, DATA_FIELD);

  if (isNil(data)) {
    return undefined;
  }

  return { event: readField(lines, EVENT_FIELD) ?? DEFAULT_EVENT, data };
}

export function parseSseBuffer(buffer: string): IParsedSseBuffer {
  const blocks = split(buffer, EVENT_SEPARATOR);
  const completeBlocks = initial(blocks);
  const events = compact(map(completeBlocks, toSseEvent));

  return { events, rest: last(blocks) ?? "" };
}
